import React from "react"

/**
 * The `SidenavSection` component is used to display a section of the sidenav.
 * All `SidenavItem` components should be nested within a `SidenavSection`.
 *
 * If the `label` prop is provided, it will be used to generate a header for the section, and the section will be labelled by the `aria-labelledby` attribute.
 *
 * @component
 * @see {@link https://planningcenter.github.io/tapestry/?path=/docs/components-sidenav--docs | Storybook Documentation}
 */
export function SidenavSection({
  children,
  className,
  label,
  subnav,
}: {
  /**
   * Default slot used to nest `SidenavItem` components.
   */
  children: React.ReactNode
  className?: string
  /**
   * Label for the section.
   */
  label?: string
  /**
   * Add subnav if this section is a subnav of a SidenavItem.
   */
  subnav?: boolean
}) {
  const subnavProps = subnav ? { slot: "subnav" } : {}
  return (
    <tds-sidenav-section class={className} label={label} {...subnavProps}>
      {children}
    </tds-sidenav-section>
  )
}
